{
	"beforeAfter": "Before/after",
	"click": "Click",
	"click2": "Click",
	"copyAdjustments": "Copy adjustments",
	"createBackgroundMask": "Create Background Mask",
	"createBrushMask": "Create Brush Mask",
	"createLinearGradientMask": "Create Linear Gradient Mask",
	"createRadialGradientMask": "Create Radial Gradient Mask",
	"createSkyMask": "Create Sky Mask",
	"createSubjectMask": "Create Subject Mask",
	"decreaseIncreaseBrushSize": "Decrease/increase Brush Size",
	"enterGroup": "Enter group",
	"exitGroup": "Exit group",
	"flagPhoto": "Flag photo",
	"goToPreviousNextPhoto": "Go to previous/next photo",
	"hidePhoto": "Hide photo",
	"hold": "Hold",
	"increaseDecreaseBasicAdjustment": "Increase/decrease basic adjustment",
	"invertCurrentMask": "Invert current mask",
	"lockEdit": "Lock Edit",
	"markAsReferenceEdit": "Mark as Reference Edit",
	"markCandidate": "Mark selected photo(s) as Candidate",
	"markReject": "Mark selected photo(s) as Reject",
	"markTopPick": "Mark selected photo(s) as Top Pick",
	"moveHealingSource": "Move Healing Source",
	"openBasicEditingMenu": "Open Basic Editing menu",
	"openCropMenu": "Open Crop menu",
	"openHealingMenu": "Open Healing menu",
	"openMaskingMenu": "Open Masking menu",
	"or": "or",
	"pasteAdjustments": "Paste adjustments",
	"pressHoldAutoExposure": "Press and hold to view with Auto Exposure",
	"previousNextBasicAdjustment": "Previous/next basic adjustment",
	"redo": "Redo",
	"rejectPhoto": "Reject photo",
	"removePhoto": "Remove photo",
	"removeStarRating": "Remove star rating",
	"revertCullingOverrides": "Revert manual culling tag overrides",
	"searchPhotos": "Search photos",
	"selectAllPhotos": "Select all photos",
	"selectMultipleContiguous": "Select multiple contiguous photos",
	"selectMultipleIndividual": "Select multiple individual photos",
	"setColorLabel": "Set color label",
	"setStarRating": "Set star rating",
	"shortcutsAreBasedOnA": "Shortcuts are based on a QWERTY keyboard. Other layouts may vary.",
	"showHideClipping": "Show/Hide Highlights and Shadows Clipping",
	"sliderAdjustmentsLarge": "Slider adjustments (large)",
	"sliderAdjustmentsSmall": "Slider adjustments (small)",
	"switchToCompareView": "Switch to Compare view",
	"switchToFocusView": "Switch to Focus view",
	"switchToGridView": "Switch to Grid view",
	"tabAiStyles": "AI Styles",
	"tabCulling": "Culling",
	"tabEditing": "Editing",
	"tabMasksHealing": "Masks & Healing",
	"tabNavigation": "Navigation",
	"tabPhotoSelection": "Photo Selection",
	"tabRatingLabeling": "Rating & Labeling",
	"text": "◀︎",
	"text2": "▶︎",
	"text3": "◀︎",
	"text4": "▶︎",
	"toSeeBefore": "to see before",
	"toggleFullScreenMode": "Toggle Full Screen Mode",
	"toggleFullScreenPreview": "Toggle Full Screen Preview",
	"undo": "Undo",
	"unflagPhoto": "Unflag photo",
	"unhidePhoto": "Unhide photo",
	"unlockEdit": "Unlock Edit",
	"unmarkReferenceEdit": "Unmark Reference Edit",
	"zoomInOut": "Zoom in/out in Focus View"
}
